import { combineReducers } from "redux";
import { SideBarReducer } from "./sidebar/SideBarReducer";
import { AboutReducer } from "./Aboutus/AboutReducer";

const rootReducers = combineReducers({
    SideBar: SideBarReducer,
    AboutUs: AboutReducer,
})

export default rootReducers